<template>
  <div class="inners">
    <div class="right">
      <div class="titles">{{ $t('common.cds73') }}</div>
      <div class="text_box">
        <div class="top_title">{{ $t('common.base.info') }}</div>
        <el-skeleton :loading="loading" animated>
          <template #template>
            <div class="info_groups">
              <div class="info_group">
                <el-skeleton-item variant="text" style="width: 60%; margin-bottom: 10px;" />
                <el-skeleton-item variant="text" style="width: 70%; margin-bottom: 10px;" />
                <el-skeleton-item variant="text" style="width: 50%; margin-bottom: 10px;" />
              </div>
              <div class="info_group">
                <el-skeleton-item variant="text" style="width: 40%; margin-bottom: 10px;" />
                <el-skeleton-item variant="text" style="width: 60%; margin-bottom: 10px;" />
                <el-skeleton-item variant="text" style="width: 50%; margin-bottom: 10px;" />
              </div>
            </div>
          </template>
          <template #default>
            <div class="info_groups">
              <div class="info_group">
                <div><span class="left_title">{{ $t('common.cds74') }}</span><span class="inner">{{
                    mailInvoice.invoiceCode
                  }}</span></div>
                <div><span class="left_title">{{ $t('common.cds75') }}</span><span class="inner">{{
                    mailInvoice.invoiceContent
                  }}</span></div>
                <div><span class="left_title">{{ $t('common.cds76') }}</span><span class="inner">¥ {{
                    mailInvoice.invoiceMoney !== null && mailInvoice.invoiceMoney !== undefined ? Number(mailInvoice.invoiceMoney).toFixed(2) : mailInvoice.invoiceMoney
                  }}</span></div>
              </div>
              <div class="info_group">
                <div>
                  <span class="left_title">{{ $t('common.cds77') }}</span>
                  <el-button link type="primary"
                             style="font-size: 14px !important;vertical-align:baseline !important;margin-left: -2px;font-weight: bold !important;"
                             @click="handleClickShowInvoiceInfo">
                    {{ $t('whatsapp.roomHeader.viewInfo') }}
                  </el-button>
                </div>
                <div><span class="left_title">{{ $t('common.cds78') }}</span><span class="inner">{{
                    mailInvoice.createTime
                  }}</span></div>
                <div>
                  <span class="left_title">{{ $t('common.cds79') }}</span>
                  <span class="inner">
                 <template v-if="mailInvoice.invoiceStatus===1">
                   <span style="color: #409eff">
                     {{ $t("invoice.status1") }}
                   </span>
                 </template>
                  <template v-else-if="mailInvoice.invoiceStatus===2">
                    <span style="color:#67c23a ">{{
                        $t("invoice.status2")
                      }}</span>
                  </template>
                  <template v-else-if="mailInvoice.invoiceStatus===3">
                    <span style="color: #d93737">
                       {{
                        $t("invoice.status3")
                      }}
                    </span>
                   </template>
                </span>
                  <el-button link type="primary"
                             :disabled="invoicePictures.length === 0"
                             style="font-size: 14px !important;vertical-align:baseline !important;margin-left: 10px;font-weight: bold !important;"
                             @click="handleClickShowFP">
                    {{ $t('common.cds85') }}
                  </el-button>
                </div>
              </div>
            </div>
          </template>
        </el-skeleton>
        <!-- <div><span class="left_title">{{ $t('common.cds81') }}</span><span
            class="inner">{{ mailInvoice.invoiceEmail }}</span></div> -->
      </div>
      <div>
        <el-table :data="mailPayOrder"
                  style="width: 100%;margin-top: 15px;"
                  v-loading="loading"
                  :cell-style="getTableCellStyle"
                  :header-cell-style="getTableHeaderCellStyle"
        >
          <el-table-column prop="orderCode" :label="$t('common.order.number')"/>
          <el-table-column prop="productName" :label="$t('common.cds83')" >
            <template #default="{row}">
              <template v-if="row?.productType && row.productType <= 4">
                {{ $t(`userinfo.vip.service.${row.productType}`) }}
              </template>
              <template v-else-if="row?.productType && row.productType > 4">
                {{ $t(`vip.type.${row.productType - 5}`) }}
              </template>
              <template v-else></template>
            </template>
          </el-table-column>
          <el-table-column prop="num" :label="$t('common.amount')"/>
          <el-table-column prop="price" :label="$t('common.unitprice')">
            <template #default="{ row }">
              {{ formatMoney(row.price) }}
            </template>
          </el-table-column>
          <el-table-column prop="totalMoney" :label="$t('common.order.amount')" >
            <template #default="{ row }">
              <span>
                ¥ {{ row.totalMoney !== null && row.totalMoney !== undefined ? Number(row.totalMoney).toFixed(2) : row.totalMoney }}
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="payMoney" :label="$t('common.amount.realpay')">
            <template #default="{ row, column, $index }">
              <span>
                ¥ {{ row.payMoney !== null && row.payMoney !== undefined && !Number.isNaN(Number(row.payMoney)) ? Number(row.payMoney).toFixed(2) : row.payMoney }}
              </span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="bottom_pay">{{ $t('common.order.amount.total') }}：<span class="reds">
        ¥ {{ totalOrderAmount.toFixed(2) }}
      </span></div>
    </div>

    <Dialog
        v-model="invoiceInfoDialogVisible"
        :title="$t('common.cds77')"
        :dialogVisible="invoiceInfoDialogVisible"
        :isHeadLine="false"
        :width="600"
        @update:dialogVisible="(val) => (invoiceInfoDialogVisible = val)"
    >
      <template #content>
        <div class="invoice-info-content">
          {{ mailInvoice.invoiceContent }}
        </div>
      </template>
      <template #footer>
        <div class="footer_btn">
          <el-button @click="invoiceInfoDialogVisible = false" size="small">{{ $t('common.close') }}</el-button>
        </div>
      </template>
    </Dialog>

    <Dialog
        v-model="invoicePictureDialogVisible"
        :title="$t('common.cds85')"
        :dialogVisible="invoicePictureDialogVisible"
        :isHeadLine="false"
        :width="800"
        @update:dialogVisible="(val) => (invoicePictureDialogVisible = val)"
    >
      <template #content>
        <div class="invoice-picture-content">
          <template v-for="(item,index) in invoicePictures" :key="index">
            <ImageShow :url="item"></ImageShow>
          </template>
        </div>
      </template>
      <template #footer>
        <div class="footer_btn">
          <el-button @click="invoicePictureDialogVisible = false" size="small">{{ $t('common.close') }}</el-button>
        </div>
      </template>
    </Dialog>
  </div>
</template>

<script setup>
import {computed, ref, onMounted} from 'vue';
import {useRouter} from "vue-router";
import {getQueryByIdInvoice} from "@/api/usercenter";
import {ElMessage} from "element-plus";
import ImageShow from "@/views/FileDoc/components/ImageShow.vue";
import Dialog from "@/components/Dialog.vue";

const router = useRouter();
const loading = ref(false)

const getTableCellStyle = ({columnIndex}) => ({
  textAlign: columnIndex === 0 ? 'left' : 'center'
})

const getTableHeaderCellStyle = ({columnIndex}) => ({
  textAlign: columnIndex === 0 ? 'left' : 'center',
  fontSize: '14px',
  color: 'black',
  fontWeight: '500',
  background: '#f9f9f9',
  padding: '8px 0px'
})

const formatMoney = (value) => {
  const amount = Number(value)
  return Number.isNaN(amount) ? `¥ ${value ?? '--'}` : `¥ ${amount.toFixed(2)}`
}


const orderCode = ref()
const mailPayOrder = ref([])
const mailInvoice = ref({})
const totalOrderAmount = computed(() => mailPayOrder.value.reduce((total, item) => {
  const amount = Number(item?.totalMoney)
  return total + (Number.isNaN(amount) ? 0 : amount)
}, 0))
const invoicePictures = computed(() => {
  const raw = mailInvoice.value?.invoicePicture
  if (Array.isArray(raw)) return raw.filter(Boolean)
  if (typeof raw !== 'string') return []
  return raw.split(',').map(item => item.trim()).filter(Boolean)
})
// 通过 id 查询数据
const getQueryByIdInvoiceApis = async () => {
  loading.value = true
  try {
    const res = await getQueryByIdInvoice(
        {id: orderCode.value}
    )
    if (res.code !== 200) {
      ElMessage.error(res.message);
      return
    }
    mailInvoice.value = res.result.mailInvoice || {};
    console.log(res.result.mailPayOrderTmpList,'res.result.mailPayOrderTmpList')
    mailPayOrder.value = res.result.mailPayOrderTmpList ? [...res.result.mailPayOrderTmpList] : []
  } finally {
    loading.value = false
  }
}


const isShowFp = ref(false)
const handleClickShowFP = () => {
  if (invoicePictures.value.length === 0) return
  invoicePictureDialogVisible.value = true
}

const invoiceInfoDialogVisible = ref(false)
const handleClickShowInvoiceInfo = () => {
  invoiceInfoDialogVisible.value = true
}

const invoicePictureDialogVisible = ref(false)

onMounted(async () => {
  const {id} = router.currentRoute.value.query
  orderCode.value = id
  await getQueryByIdInvoiceApis()
})
</script>

<style lang="less" scoped>
@import "./less/Tables.less";

.text_box {
  & > div {
    margin-bottom: 10px;
  }
}

.info_groups {
  display: flex;
  gap: 40px;
}

.info_group {
  flex: 1;
  & > div {
    margin-bottom: 10px;
  }
}

.left_title {
  color: #999;
  margin-right: 20px;
  font-size: 14px;
}

.right {
  min-height: 640px;
  height: auto;
}

.bottom_pay {
  display: flex;
  justify-content: flex-end;
  align-content: center;
  margin-top: 20px;
  font-size: 14px;

  .reds {
    color: #c8453f;
    font-size: 14px;
    font-weight: bold;
  }
}

.inner {
  font-size: 14px;
  font-weight: bold;
}

:deep(.el-table .cell) {
  font-size: 14px !important;
  font-weight: normal !important;
}

.invoice-info-content {
  word-wrap: break-word;
  word-break: break-all;
  white-space: pre-wrap;
  line-height: 1.6;
  font-size: 14px;
  max-height: 400px;
  overflow-y: auto;
  padding: 10px;
}

.footer_btn {
  width: 100%;
  display: flex;
  justify-content: flex-end;
}

.invoice-picture-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  max-height: 500px;
  overflow-y: auto;
  padding: 10px;
}

.bottom_pay {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: 20px;
  font-size: 14px;

  .reds {
    color: var(--el-color-danger);
    font-size: 14px;
    font-weight: bold;
  }
}
</style>
